import React from 'react';
import { useStore } from '../../context/StoreContext';

const StoreSelector = () => {
  const { userStores, selectStore, showStoreSelector } = useStore();

  // This component only renders when the context tells it to.
  if (!showStoreSelector) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 z-[9999] flex justify-center items-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md max-h-[calc(100vh-2rem)] flex flex-col">
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">Select a Store to Continue</h2>
        <div className="space-y-4 overflow-y-auto pr-1">
          {userStores.map(store => (
            <button
              key={store._id}
              onClick={() => selectStore(store)}
              className="w-full text-left p-4 border rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
            >
              <p className="font-semibold text-lg text-gray-900">{store.name}</p>
              <p className="text-sm text-gray-500">{store.type}</p>
            </button>
          ))}
        </div>
        {userStores.length === 0 && (
            <p className="text-center text-red-500 mt-4">
              You have not been assigned to any stores. Please contact an administrator.
            </p>
        )}
      </div>
    </div>
  );
};

export default StoreSelector;
